import { http } from "../../../shared/api/http"
import { Experience } from "../../../pages/profiles/types"

export type ExperienceListResponse = {
  items: Experience[]
  total: number
}

export const listMyExperiencesApi = () => {
  return http.get<ExperienceListResponse>("api/users/me/experiences")
}

export const createExperienceApi = (
  data: Omit<Experience, "id">
) => {
  return http.post<Experience>("api/users/me/experiences", data)
}

export const deleteExperienceApi = (id: string) => {
  return http.delete<void>(`api/users/me/experiences/${id}`)
}
